export var strikethrough = {
    parseDOM: [
        { tag: 'strike' },
        { style: 'text-decoration=line-through' },
        { style: 'text-decoration-line=line-through' },
    ],
    toDOM: function () { return ['span', { style: 'text-decoration-line:line-through' }]; },
};
